import { useTranslation } from '@aimsos/i18n';

import NextBestActionSection from './NextBestActionSection.jsx';
import NextBestActionStepList from './NextBestActionStepList.jsx';

/** "Review workflow": the journey (N steps, estimated time) and what starting it does (CT-5713). */
function NextBestActionJourney({ workflow }) {
  const { t } = useTranslation('unified-profiles');

  return (
    <div className="flex flex-col gap-6">
      <NextBestActionSection
        title={t('profile.nba.journey', { count: workflow.steps.length, time: workflow.estimatedTime ?? '—' })}
        testId="nba-journey"
      >
        <NextBestActionStepList steps={workflow.steps} />
      </NextBestActionSection>
      {workflow.onStart.length ? (
        <NextBestActionSection title={t('profile.nba.whenYouStart')}>
          <ul className="flex list-disc flex-col gap-1 pl-5 text-sm text-content-secondary">
            {workflow.onStart.map((line) => (
              <li key={line}>{line}</li>
            ))}
          </ul>
        </NextBestActionSection>
      ) : null}
    </div>
  );
}

export default NextBestActionJourney;
